The hiring organization that created the questionnaire.

The questionnaire can be attached to job ads posted by this organization.
